/**
 * Primitive types used as content by {@link PolymorphOutletDirective}
 */
export type PolymorphPrimitive = string | number;
